<script>
import { filterSysComOut } from "../../../config/comments.config";

/**
 * @typedef {Object} ParsedComment - Formato do comentário para exibição em tela
 * @property {string} comentario - Texto do comentário
 * @property {string} data - Data do comentário
 * @property {string} dateTime - Data do comentário formatada para exibição
 * @property {string} responsavel - Autor do comentário no formado `NOME (E-MAIL)`
 * @property {string} workflow - Nome da etapa onde o comentário foi realizado
 */

export default {
  props: {
    comments: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    /**
     * Lista de comentários dos usuários formatados para exibição
     * @type {ParsedComment[]}
     * @readonly
     */
    sortedcomments() {
      const comments = this.comments
        .filter(filterSysComOut)
        .map(({ data, responsavel, workflow_nome, ...rest }) => {
          let responsavelLabel = "Desconhecido";

          if (responsavel?.nome && responsavel?.email) {
            responsavelLabel = `${responsavel.nome} (${responsavel.email})`;
          } else if (responsavel?.nome || responsavel?.email) {
            responsavelLabel = responsavel.nome || responsavel.email;
          }

          return {
            ...rest,
            data,
            dateTime: this.$options.filters.toDateTime(data),
            responsavel: responsavelLabel,
            workflow: workflow_nome ?? "Desconhecido"
          };
        });
      comments.sort(({ data: a }, { data: b }) => b?.localeCompare(a || ""));
      return comments;
    }
  }
};
</script>

<template>
  <div class="comments-list comments-list-container">
    <div
      class="comment-item"
      v-for="comment of sortedcomments"
      :key="comment.id"
    >
      <div class="comment-responsible">
        <span class="comment-responsible-label">
          Responsavel:
        </span>
        <span>
          {{ comment.responsavel }}
        </span>
      </div>
      <div class="comment-responsible">
        <span class="comment-responsible-label">
          Etapa:
        </span>
        <span>
          {{ comment.workflow }}
        </span>
      </div>
      <div class="comment-responsible">
        <span class="comment-responsible-label">
          Data e horário:
        </span>
        <span>
          {{ comment.dateTime }}
        </span>
      </div>
      <div class="comment">{{ comment.comentario }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.comments-list {
  &.comments-list-container {
    display: flex;
    flex-direction: column;
    align-content: space-between;
    padding-bottom: 1rem;
  }

  .comment-item {
    padding: 0.75rem 1rem;
    background-color: var(--v-table-header-base);
    border-radius: 0.25rem;
  }

  .comment-item + .comment-item {
    border-top: solid thin white;
    margin-top: 0.25rem;
  }

  .comment {
    font-size: 1rem;
    font-weight: 400;
    padding: 0.25rem;
    text-align: justify;
  }

  .comment-responsible {
    display: flex;
    font-size: 0.85rem;
    font-weight: 300;
    margin-top: 0.25rem;

    .comment-responsible-label {
      font-weight: bold;
      margin-right: 0.25rem;
    }
  }
}
</style>
